import { render, staticRenderFns } from "./ExpireMileage.vue?vue&type=template&id=0282feb0"
import script from "./ExpireMileage.vue?vue&type=script&lang=js"
export * from "./ExpireMileage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0282feb0')) {
      api.createRecord('0282feb0', component.options)
    } else {
      api.reload('0282feb0', component.options)
    }
    module.hot.accept("./ExpireMileage.vue?vue&type=template&id=0282feb0", function () {
      api.rerender('0282feb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/user/popup/ExpireMileage.vue"
export default component.exports